import { css } from '@emotion/css';

export const popperStyles = css`
  &[data-popper-placement='top'] .MuiTooltip-arrow::before {
    margin-top: -1px;
  }
  &[data-popper-placement='bottom'] .MuiTooltip-arrow::before {
    margin-top: 1px;
  }
  &[data-popper-placement='left'] .MuiTooltip-arrow::before {
    margin-inline-start: -1px;
  }
  &[data-popper-placement='right'] .MuiTooltip-arrow::before {
    margin-inline-start: 1px;
  }
`;
